<div class="{{additionalContainerClass}}" [class.control-shrinked-container]="isShrinked">
  <label [for]="inputID" class="input-title" *ngIf="title">
    {{title}}<span *ngIf="isRequired" class="red-10">*</span>
  </label>
  <div class="control {{additionalClass}}">
    <label [for]="inputID" class="prefix" *ngIf="prefixFirstImgSrc||prefixSecondImgSrc">
      <img [src]="prefixFirstImgSrc" *ngIf="prefixFirstImgSrc" alt="prefix-img">
      <img [src]="prefixSecondImgSrc" *ngIf="prefixSecondImgSrc" alt="prefix-img">
    </label>

    <!-- HERE IS YOUR INPUT -->
    <input
      data-qa="date-input"
      class="{{fontClass}}"
      [placeholder]="placeholder"
      [id]="inputID"
      [(ngModel)]="input"
      (ngModelChange)="onInputChange($event)"
      [min]="minDate"
      [max]="maxDate"
      [type]="type"
      [disabled]="disabled"
      (blur)="blurEmitter.emit($event)"
      [class.not-entered-input]="!input">


    <label [for]="inputID" class="suffix" *ngIf="suffixFirstImgSrc || suffixSecondImgSrc">
      <div class="fixed-pos-tooltip" *ngIf="suffixFirstImgSrc">
        <img [src]="suffixFirstImgSrc" alt="suffix-img">
        <div *ngIf="firstSuffixImageTooltip" class="fms-tooltip fixed-pos-tooltip-container">
          <div class="fms-tooltip-body w-max"> {{ firstSuffixImageTooltip }}</div>
        </div>
      </div>

      <div class="fixed-pos-tooltip" *ngIf="suffixSecondImgSrc">
        <img [src]="suffixSecondImgSrc" alt="suffix-img">
        <div *ngIf="secondSuffixImageTooltip" class="fms-tooltip fixed-pos-tooltip-container">
          <div class="fms-tooltip-body w-max"> {{ secondSuffixImageTooltip }}</div>
        </div>
      </div>
    </label>

    <label [for]="inputID" class="control-bottom">{{bottomText}}</label>
  </div>
</div>
